<!--  -->
<template>
  <div class="tewbox">
    <el-input v-model="query.keywords" style="width:300px;margin-right:10px" placeholder="企业id/自有员工编号/员工ID/员工姓名" />
    <el-select v-model="query.onlyMe" placeholder="请选择" style="width:150px">
      <el-option
        v-for="item in accountarr"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="sraw">搜索</el-button>
    <el-button type="info" icon="el-icon-refresh-right" @click="awered">重置</el-button>
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top: 20px;"
    >
      <el-table-column
        prop="name"
        label="员工名字"
        width="300"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" :disabled="scope.row.can_checked === 9" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { corpUsersListForFrequency } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        keywords: null,
        onlyMe: 2
      },
      tableData: [],
      total: null,
      accountarr: [{
        value: 1,
        label: '查看组内员工'
      }, {
        value: 2,
        label: '我关联的员工'
      }]
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendrs() {
      this.temlist()
    },
    async temlist() {
      const data = await corpUsersListForFrequency(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.temlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.temlist()
    },
    choose(item) {
      this.$emit('choserdanr', item)
      console.log('item', item)
    },
    sraw() {
      this.query.page = 1
      this.temlist()
    },
    awered() {
      this.query.page = 1
      this.query.keywords = null
      this.query.onlyMe = 2
      this.temlist()
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tewbox{
  padding: 10px;
}
</style>
